import { useIntl } from 'react-intl';
import { Box, Button, Link, useDeviceType } from '@packages/shared';
import { basicContainer } from './styles';
import { generalFormMessages } from './messages';

export enum FormFooterAreaTestIds {
  main = 'form-footer-area-container',
  header = 'form-footer-area-header',
  form = 'form-footer-area-form',
  button = 'form-footer-area-button-submit',
  buttonDisabled = 'form-footer-area-button-submit-disabled',
}

export type FormFooterAreaProps = {
  /** Indicates that the form is valid and the button should be enabled */
  isValid: boolean;
  submitForm: () => Promise<void>;
  submitButton: {
    /** Button text when the button is enabled */
    enabled: string;
    /** Button text when the button is disabled */
    disabled: string;
  };
};

/**
 * Renders the bottom area of the form with a button and a link back to storefront
 */
export const FormFooterArea = ({ isValid, submitForm, submitButton }: FormFooterAreaProps) => {
  const intl = useIntl();
  const { isMobile } = useDeviceType();

  return (
    <Box
      sx={{ ...basicContainer, textAlign: 'center', paddingTop: 2 }}
      data-testid={FormFooterAreaTestIds.main}
    >
      <Button
        data-testid={isValid ? FormFooterAreaTestIds.button : FormFooterAreaTestIds.buttonDisabled}
        disabled={!isValid}
        size="large"
        fullWidth={isMobile}
        onClick={submitForm}
        color="primary"
      >
        {isValid ? submitButton.enabled : submitButton.disabled}
      </Button>

      <Box sx={{ ...basicContainer, color: 'text.darkTransparent' }}>
        <Link href="/" color="inherit" sx={{ paddingTop: 2.5, display: 'block' }}>
          {intl.formatMessage(generalFormMessages.backToStorefront)}
        </Link>
        <Box sx={{ paddingTop: 4, typography: 'body3' }}>
          {intl.formatMessage(generalFormMessages.mandatory)}
        </Box>
      </Box>
    </Box>
  );
};
